<template>
    <b-list-group-item 
        class="d-flex justify-content-between align-items-center py-2 border-none border-0">
        <div class="d-flex">
            <b-avatar :variant="design.is_active ? (design.is_published ? 'primary' : 'light') : 'danger'">
                <i class="fa fa-paint-brush fa-xl p-2"></i>
            </b-avatar>
            <div class="ml-1 w-100 d-block">
                <!-- Título -->
                <span>{{ design.title }}</span>

                <!-- Dimensiones y estado de publicación -->
                <div class="d-flex align-items-center flex-wrap">
                    <!-- Dimensiones -->
                    <b-badge variant="light">{{ design.width }} cm · {{ design.height }} cm</b-badge>
                    <span v-if="design.is_published" class="mx-2">·</span>
                    <!-- Estado de publicación -->
                    <b-badge v-if="design.is_published" class="text-white" variant="info">
                        <i :class="`fa fa-check`"></i>
                        Publicado
                    </b-badge>
                </div>
                                
            </div>
        </div>
        <div class="d-flex align-items-center">

            <!-- Editar -->
            <i v-b-tooltip.hover title="Editar diseño" class="fa fa-edit fa-lg cursor-pointer text-info"
                @click="onHandleEditDesign(type, design)"></i>

            <!-- Duplicar -->
            <i v-b-tooltip.hover title="Duplicar diseño" class="fa fa-clone fa mx-2 cursor-pointer" :class="design.is_active ? 'text-primary' : 'text-secondary'"
                @click="onHandleDuplicateDesign(type, design)"></i>

            <!-- Borrar -->
            <i v-b-tooltip.hover title="Inactivar | Activar diseño" class="fa fa-lg cursor-pointer" :class="!design.is_active ? 'fa-check text-primary' : 'fa-close text-danger'"
                @click="onHandleDeleteDesign(type, design)"></i>
        
        </div>
    </b-list-group-item>
</template>

<script>

import { mapMutations, mapActions, mapState } from 'vuex';

export default {

    props: {
        type: {
            type: String,
            required: false,
            default: 'GENERAL'
        },
        design: {
            type: Object,
            required: true,
        },
        companyId: {
            type: [Number,String],
            required: false,
            default: null
        }
    },

    computed: {

        ...mapState("Reporteinventario", {
            companies: 'listaEmpresas'
        }),

        ...mapState("dashboard", {
            globalLoading: 'cargando_datos_select'
        }),

        getCompany() {
            try {
                return this.companies.find(company => company.id === this.companyId)
            } catch (e) {
                return null
            }
        }
    },

    methods: {

        ...mapMutations('labelDesigner', [
            'setActiveSection',
            'setSelectedLayout',
            'setActiveTab',
            'setDuplicateDesign'
        ]),

        ...mapActions('labelDesigner', {
            changeStateLabelDesign: 'changeState',
            getLabelDesigns: 'getLabelDesigns',
        }),

        /* 
         * Edición de un diseño
         * type: GENERAL o BY_COMPANY
         * design: objeto del diseño
         */
        onHandleEditDesign(type = 'GENERAL', design) {
            this.setActiveSection(null)

            let layout = []
            let countries_ids = []
            let company_id = null
            let orientation = false

            if (design.data) {
                const data = JSON.parse(design.data);
                layout = data.layout
                countries_ids = data.countries_ids
                orientation = data.orientation

                if (type === 'BY_COMPANY') company_id = this.companyId
            }

            this.setSelectedLayout({
                ...this.selectedLayout,
                id: design.id,
                title: design.title,
                gridWidthCm: design.width,
                gridHeightCm: design.height,
                is_published: design.is_published,
                is_published_temporary: design.is_published,
                layout,
                countries_ids,
                countries: type === 'BY_COMPANY' ? (design.company_countries || []) : (design.countries || []),
                company_id,
                type,
                orientation
            })
            this.setActiveTab(2)
        },

        /* 
         * Duplicación de un diseño
         * type: GENERAL o BY_COMPANY
         * design: objeto del diseño
         */
        onHandleDuplicateDesign(type = 'GENERAL', design) {
            this.setDuplicateDesign({
                is_showing: true,
                design,
                type,
                company: this.getCompany,
                to_company_id: null,
                new_design_title: design.title + ' (Copia)'
            })
        },

        /* 
         * Borrado de un diseño
         * type: GENERAL o BY_COMPANY
         * design: objeto del diseño
         */
        async onHandleDeleteDesign(type = 'GENERAL', design) {
            let payload = {
                id: design.id,
                company_id: type === 'BY_COMPANY' ? this.companyId : null
            }

            await this.changeStateLabelDesign(payload)
        }

    }

}
</script>

<style scoped></style>
